import { BaseObject } from "@adgate/common/types/base-object.type";
import { CommercialType } from "@adgate/common/types/commercial-type.type";
import { Status } from "@adgate/common/types/status.type";

export class ProductionVersion extends BaseObject
{
    public static OBJECT_TYPE:number = 5;

    requestId!: number;
    type!: CommercialType;
    name!: string;
    notes!: string;
    dateCreated!: number | null;
    txId!: string;
    status: Status;
    lastModified: number = 0;

    constructor()
    {
        super();
        this.status = { id: Status.PRODUCTION_VERSION_CREATED, description: 'Created' };
    }
}